import { BaseDetail } from 'App/Component/Bases'
import fields from 'App/Screens/Job/BuildingTypes/fields'

class PageAdd extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = 'Building Type'
    this.urlData = 'module-job-buildingType'
    this.fields = fields
    this.state = {
      isCheckingPermission: false,
      isAccessAllowed: true
    }
  }
}

export default PageAdd